import React from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import {
  Visibility,
  VisibilityOff,
  Lock,
  Person
} from '@material-ui/icons'

import { Alert, CustomButton } from 'components'
import { useLoginForm } from '../../hooks/useLoginForm'
import useStyles from './LoginForm.styles'

export const LoginForm = (props) => {
  const { className, mobile, ...rest } = props
  const classes = useStyles()
  const session = useSelector((state) => state.session)

  const {
    formState,
    isLoading,
    showPassword,
    handleChange,
    handleSubmit,
    toggleShowPassword,
    hasError,
  } = useLoginForm()

  return (
    <form {...rest} className={clsx(classes.root, className)} onSubmit={handleSubmit}>
      {/* Alertas de Erro/Sucesso vindos da Store de Sessão */}
      <div className={classes.alert}>
        {session.erroLogin || session.cpfSenhaIncorretos ? (
          <Alert 
            variant="error" 
            message={session.erroLogin ? 'Erro ao realizar login' : 'CPF ou Senha inválidos'} 
          />
        ) : null}
        {session.tokenExpirado ? (
          <Alert variant="error" message="Sua sessão expirou. Faça login novamente." />
        ) : null}
        {session.senhaRedefinida ? (
          <Alert variant="success" message="Senha definida com sucesso." />
        ) : null}
        {session.solicitar_redefinir_senha_sucesso ? (
          <Alert variant="success" message="Solicitação efetuada com sucesso. Verifique seu e-mail." />
        ) : null}
      </div>

      <div className={classes.fieldsContainer}>
        {/* Campo CPF */}
        <TextField
          id="cpf"
          name="cpf"
          label="CPF"
          variant="outlined"
          fullWidth
          className={classes.fieldWrapper}
          value={formState.values.cpf || ''}
          onChange={handleChange}
          error={hasError('cpf')}
          helperText={hasError('cpf') ? 'Digite um CPF válido' : null}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.iconAdornment}>
                <Person fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {/* Campo Senha */}
        <TextField
          id="senha"
          name="senha"
          label="Senha"
          type={showPassword ? 'text' : 'password'}
          variant="outlined"
          fullWidth
          className={classes.fieldWrapper}
          value={formState.values.senha || ''}
          onChange={handleChange}
          error={hasError('senha')}
          helperText={hasError('senha') ? formState.errors.senha[0] : null}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.iconAdornment}>
                <Lock fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Alternar visibilidade da senha"
                  onClick={toggleShowPassword}
                  edge="end"
                  className={classes.passwordToggle}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      {/* Botão customizado padrão SIGEP */}
      <CustomButton
        type="submit"
        colorType="primary"
        variant="contained"
        fullWidth
        className={classes.submitButton}
        disabled={!formState.isValid || isLoading}
        isLoading={isLoading}
        size={mobile ? 'medium' : 'large'}
      >
        Entrar
      </CustomButton>
    </form>
  )
}
